export const clearUserCache = () => {
  localStorage.removeItem('jwt_token');
  localStorage.removeItem('jwt_expire');
  localStorage.removeItem('pending_agreement');
  // Add other user-specific keys here if needed
};
